import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { refreshToken } from '../utils/Token';
import axios from 'axios';

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const [message, setMessage] = useState('');

    const token = Cookies.get('token');

    useEffect(() => {
        if (!token) {
            return <Navigate to="/login" />;
        }
        
        const fetcUserRole = async () => {
            try {
                const token = Cookies.get('token');
                const response = await axios.get('/api/checkRole', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const role = response.data.role;
                const userStatus = response.data.userStatus;
                Cookies.set('role', role);

                if (role != 'user') {
                    // remove token
                    Cookies.remove('token');
                    Cookies.remove('role');

                    navigate('/login');
                }

                // if (userStatus != 'active') {
                //     navigate('/kyc-verify');
                // }

            } catch (error) {
                Cookies.remove('token');
                Cookies.remove('role');

                setMessage('Error checking user role');
                navigate('/login');
            }
        };

        const fetcUserStatus = async () => {
            try {
                const token = Cookies.get('token');
                const response = await axios.get('/api/checkStatus', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const userStatus = response.data.status;
                const kycStatus = response.data.kycStatus;

                Cookies.set('userStatus', userStatus, { secure: true, sameSite: 'Strict' });
                Cookies.set('kycStatus', kycStatus, { secure: true, sameSite: 'Strict' });
            } catch (error) {
                console.error('Error checking user status:', error);
            }
        };

        fetcUserRole();

        fetcUserStatus();

        const interval = setInterval(() => {
            refreshToken();
        }, 15 * 60 * 1000); // Refresh token every 15 minutes

        return () => clearInterval(interval);
    }, [navigate]);

    return children;
};

export default ProtectedRoute;